import { Feedback } from "@/models/Feedback";
import { APIMutationResponse, useAPIMutation } from "../useAPI";
import endpoints from "./feedbacks.endpoint";
import { FeedbackRequest, FeedbackResponse } from "./feedbacks.type";

export const useSendFeedbacks = (threadId: string): APIMutationResponse<void, Feedback> => {
  return useAPIMutation<FeedbackRequest, FeedbackResponse, Feedback, void>(
    "POST",
    endpoints.POST_FEEDBACK(threadId),
    modelToRequest,
    () => {},
  );
};

const modelToRequest = (model: Feedback): FeedbackRequest => {
  return {
    id: model.id,
    messageId: model.messageId,
    score: model.score,
    comment: model.comment,
  };
};
